import React from "react"
import config from "react-global-configuration"
import { getContentEnrichedProduct } from "../../helpers/bookingHelper"
import * as tracking from "../../../booking/helpers/tracking"
import Svg from "../../../shared/_svgs/svg"
import { parkingState } from "../../zustand/parkingState"
import priceFormatter from "../../helpers/priceFormatter"
import { handleReservation } from "../../helpers/apiHelper"
import { FlowEnum } from "../../constants/flowEnums"

const MapMarkerParking = (props) => {
  const { item, isInModal, isCenter, isSingle, disableReservation, history } = props

  const handleSpecialProductClick = () => {
    parkingState.setState({
      parkingDetailsModalGaList: parkingState.getState().gaList,
      parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(item, config.get("content")),
    })
  }

  const handleMemberProductClick = () => {
    parkingState.setState({
      parkingDetailsModalGaList: parkingState.getState().gaList,
      parkingDetailsModalGaListIndex: parkingState.getState().gaListIndex,
      isParkingMemberProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(item, config.get("content")),
    })
  }

  const handleClickFunction = (isSpecialProduct, showMemberprice, isLoggedIn, product, carPark) => {
    // tracking.trackParkingEngagementClick('parking - map', `gå til booking - click - ${product.name} ${carPark.name}`)
    if (isSpecialProduct) {
      handleSpecialProductClick()
    } else if (showMemberprice && !isLoggedIn) {
      handleMemberProductClick()
    } else {
      handleReservation(product.id, item, null, history)
    }
  }

  const handlePinClick = (product) => {
    tracking.trackParkingEngagementClick("parking - map", `pin - click - ${product.name}`)
  }

  const { globals, changeFromBooking = undefined } = parkingState.getState()
  const { product, carPark, result } = item
  const textKeys = config.get("textKeys.parkingList.listElement") || {}
  const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
  const { userAccountDetails } = parkingState.getState()
  // if (product.isSoldOut && ! parkingState.getState().isInModal) return null

  const isAmendment = parkingState.getState().currentFlow === FlowEnum.AMENDMENTFLOWCHANGECARPARK

  //membercheckup.
  const isLoggedIn = !!userAccountDetails
  const changeFromLoggedIn = !!parkingState.getState().changeFromBooking?.booking?.membershipNumber
  const hasLoggedInInfo = !!(isLoggedIn || changeFromLoggedIn)

  let matchingBooking = false
  if (isAmendment && changeFromBooking?.booking?.carParkId === carPark.id) {
    matchingBooking = true
  }

  let membershipCarParks = [77, 71]
  const isSpecialProduct = product?.dynamicFields?.isSpecialProduct
  const showMemberprice = result?.showMemberPrice
  const membershipCarParksCheck = membershipCarParks.includes(carPark?.id) && result?.memberPrice === 0
  const isMembershipCarpark = membershipCarParks.includes(carPark?.id)

  let showMembershipPriceLabel = false
  showMembershipPriceLabel = !membershipCarParksCheck && !hasLoggedInInfo ? true : false

  if (!isMembershipCarpark) {
    showMembershipPriceLabel = false
  }

  let changeFromBookingPrice = 0
  if (changeFromBooking) {
    changeFromBookingPrice = changeFromBooking.booking.items.parkings[0].amount
  }

  let positiveMemberPrice
  let positiveTotalPrice
  if (isAmendment) {
    positiveMemberPrice = result?.memberPrice - changeFromBookingPrice > 0 ? "+" : ""
    positiveTotalPrice = result?.totalPrice - changeFromBookingPrice > 0 ? "+" : ""
  }

  let promotionBanner =
    result?.originalPrice > result?.totalPrice && globals.promotionName
      ? globals.promotionName
      : result?.thirdPartyPromoLabelText
        ? result.thirdPartyPromoLabelText
        : product.dynamicFields?.calloutBanner

  // use affiliateBanner if an affiliateCode is active
  const affiliateCheck = parkingState.getState().affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
  if (affiliateCheck) {
    promotionBanner = product.dynamicFields.affiliateBanner
  }

  let bubbleColor = product?.dynamicFields?.productColor
  if (
    carPark.code !== "P4S" &&
    result?.thirdPartyPromoLabelColorCode &&
    !affiliateCheck &&
    (result?.showOriginalPrice || result?.showPayOnFootPrice) &&
    !(result?.originalPrice > result?.totalPrice && globals.promotionName)
  ) {
    bubbleColor = result.thirdPartyPromoLabelColorCode
  } else if (carPark.code !== "P4S" && (result?.showOriginalPrice || result?.showPayOnFootPrice || affiliateCheck)) {
    bubbleColor = "#fecb00"
  }

  if (product.dynamicFields && product.dynamicFields.productLeftV2 && product.dynamicFields.productTopV2) {
    // only render markers that have a position
    return (
      <div
        className={`map-marker map-marker--parking ${matchingBooking ? "map-current" : ""} ${
          isInModal ? "is-disabled" : ""
        } ${product.isSoldOut ? "map-marker--soldout" : ""}`}
        data-center={isCenter || isSingle ? true : false}
        data-positionstyle={`left:${product.dynamicFields.productLeftV2}%;top:${product.dynamicFields.productTopV2}%;`}
        data-positionx={product.dynamicFields.productLeftV2}
        data-positiony={product.dynamicFields.productTopV2}
        onClick={() => handlePinClick(product)}
      >
        <div className="bubble" style={{ backgroundColor: product.isSoldOut ? "#a4a8ad" : bubbleColor }}>
          {product.categoryName && product.categoryName.startsWith("We Park You Fly") ? (
            <>
              <span className="icon">
                <svg className="svg-icon svg-icon--keypickup">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-keypickup">
                    &nbsp;
                  </use>
                </svg>
              </span>
              <strong>×</strong>
            </>
          ) : (
            <>
              <span>{carPark.name}</span>
              <strong>×</strong>
            </>
          )}
        </div>
        {result ? (
          <div className="label">
            <span className="label__inner">
              <strong className={isAmendment ? "amendment-label" : ""}>
                {isAmendment
                  ? showMemberprice
                    ? result.memberOriginalPrice - changeFromBookingPrice > 0
                      ? "+"
                      : ""
                    : result.totalPrice - changeFromBookingPrice > 0
                      ? "+"
                      : ""
                  : ""}

                {priceFormatter(
                  isAmendment
                    ? showMemberprice
                      ? result.memberOriginalPrice - changeFromBookingPrice
                      : result.totalPrice - changeFromBookingPrice
                    : result.totalPrice,
                )}
                {matchingBooking ? (
                  <div className="check-container">
                    <Svg iconName={"checkmark"} fillColor={"#000"} />
                  </div>
                ) : (
                  ""
                )}
              </strong>
            </span>
          </div>
        ) : null}
        {!isInModal ? (
          <div className="content">
            <div className="content__inner">
              {promotionBanner ? (
                <span className="angled-ribbon angled-ribbon--map-marker map-marker--parking">
                  <span
                    className="angled-ribbon__inner"
                    style={{
                      backgroundColor:
                        !affiliateCheck &&
                        !(result?.originalPrice > result?.totalPrice && globals.promotionName) &&
                        result?.thirdPartyPromoLabelColorCode
                          ? result.thirdPartyPromoLabelColorCode
                          : null,
                    }}
                  >
                    <span className="text">{promotionBanner}</span>
                  </span>
                </span>
              ) : (
                ""
              )}
              <div className="details">
                <div className="title">
                  <h4>
                    {product.name} <em>{carPark.name}</em>
                  </h4>
                </div>
                <div className="features">
                  {carPark.transferMethod === "Bus" ? (
                    <p>
                      <svg className="svg-icon svg-icon--bus">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-bus"></use>
                      </svg>
                      <span>
                        {carPark.transferTime} {textKeys.busTime || "min. i bus til terminalen"}
                      </span>
                    </p>
                  ) : (
                    <p>
                      <svg className="svg-icon svg-icon--bus">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-passenger"></use>
                      </svg>
                      <span>
                        {carPark.transferTime} {textKeys.walkTime || "min. gang til terminalen"}
                      </span>
                    </p>
                  )}
                  {product.dynamicFields?.productValet ? (
                    <p>
                      <svg className="svg-icon svg-icon--keypickup">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-keypickup"></use>
                      </svg>
                      <span>{textKeys.indoorDeliverOutdoorParking || "Indendørs aflevering - udendørs parkering"}</span>
                    </p>
                  ) : carPark.transferFrequency === 1 ? (
                    <p>
                      <svg className="svg-icon svg-icon--sun">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
                      </svg>
                      <span>{textKeys.outdoorParking || "Udendørs parkeringsanlæg"}</span>
                    </p>
                  ) : carPark.transferFrequency === 2 ? (
                    <p>
                      <svg className="svg-icon svg-icon--sun">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-carindoors"></use>
                      </svg>
                      <span>{textKeys.indoorParking || "Indendørs parkeringsanlæg"}</span>
                    </p>
                  ) : carPark.transferFrequency === 3 ? (
                    <p>
                      <svg className="svg-icon svg-icon--sun">
                        <use xlinkHref="/dist/svg/symbols.svg#svg-sun"></use>
                      </svg>
                      <span>{textKeys.in_outdoorParking || "Inden- og udendørsparkering"}</span>
                    </p>
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: `<!-- ${JSON.stringify(carPark)} -->` }} />
                  )}
                </div>
              </div>
              {result ? (
                <div className="price">
                  <span className="price__inner">
                    {isAmendment ? (
                      <div>
                        {isMembershipCarpark ? <h6>{textKeys.memberPrice}</h6> : null}
                        <h5>
                          <strong>
                            {result.showMemberPrice ? positiveMemberPrice : positiveTotalPrice}
                            {priceFormatter(
                              result.showMemberPrice ? result.memberPrice - changeFromBookingPrice : result.totalPrice - changeFromBookingPrice,
                            )}
                          </strong>
                        </h5>

                        <p>
                          {textKeys.totalPrice || "Total: "} {priceFormatter(result.showMemberPrice ? result.memberPrice : result.totalPrice)}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <h6>{result.showMemberPrice ? textKeys.memberPrice : textKeys.onlinePrice || "Onlinepris: "}</h6>
                        <h5>
                          <strong>{priceFormatter(result.showMemberPrice ? result.memberPrice : result.totalPrice)}</strong>
                        </h5>
                        {result.showMemberPrice ? (
                          <p className={hasLoggedInInfo ? "price-line-through " : null}>
                            {textKeys.nonMemberPrice} <span>{priceFormatter(result.totalPrice)}</span>
                          </p>
                        ) : null}
                        {result?.showPayOnFootPrice ? (
                          <p>
                            {textKeys.normalOnlinePrice || "Normal onlinepris:"}{" "}
                            <span className={"line-through"}>{priceFormatter(result.payOnFootPrice)}</span>
                          </p>
                        ) : null}
                        {result?.showOriginalPrice ? (
                          <p>
                            {textKeys.previousPrice || "Førpris:"} <span className={"line-through"}>{priceFormatter(result.originalPrice)}</span>
                          </p>
                        ) : null}
                        {result?.showDriveInPrice ? (
                          <p>
                            {textKeys.drivePrice || "Drive in-pris:"} <span>{priceFormatter(result.barrierTariff)}</span>
                          </p>
                        ) : null}
                      </div>
                    )}
                  </span>

                  {!disableReservation ? (
                    product.isSoldOut ? (
                      <button className="button button--small button--general is-disabled">
                        <span className="text">
                          {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed
                            ? wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"
                            : textKeys.soldOut || "Udsolgt"}
                        </span>
                      </button>
                    ) : (
                      <button
                        className="button button--small button--general js--mobile-deactivate"
                        onClick={() => handleClickFunction(isSpecialProduct, showMemberprice, hasLoggedInInfo, product, carPark)}
                      >
                        <span className="text">{textKeys.reserve || "Reservér"}</span>
                      </button>
                    )
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
  return null
}

export default MapMarkerParking
